export default __webpack_public_path__ + "static/embr-e872fdb7a9e7448fbe00cc4732cff46d.svg";